import React from "react";
import { makeStyles, Paper, Theme, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => {
  return {
    sectionHeading: {
      color: "#9f9f9f",
      fontSize: "1.1em",
      marginBottom: "30px",
      fontWeight: 600,
      position: "relative",
    },
    formBody: {
      marginLeft: 20,
    },
    formSection: {
      padding: 30,
      boxShadow: "0 0 19px -2px hsla(0,0%,63.9%,.3)",
      border: "1px solid #ddd",
      backgroundColor: "#fff",
      borderRadius: "3px",
    },
    formHeading: {
      color: "#9f9f9f",
      fontSize: "1em",
      marginBottom: "30px",
      fontWeight: 600,
      position: "relative",
      marginTop: "0",
    },
  };
});

export const NewApplicationContent: React.FC = () => {
  const classes = useStyles();
  return (
    <>
      <h6 className={classes.formHeading}>
        Creating a Scope Expansion Application
      </h6>
      <Paper className={classes.formSection}>
        <h3 className={classes.sectionHeading}>Application title</h3>
        <Typography variant="body1" className={classes.formBody}>
          Please write an appropriate title to your application here. You can
          use this to find your application in the future on the organisatons
          page.
        </Typography>
        <h3 className={classes.sectionHeading}>Question 1</h3>
        <Typography variant="body1" className={classes.formBody}>
          Using the add scope button, please identify the type of qualifications
          you wish to offer. Only complete the 'Qualification Description' box
          if you cannot describe the qualifications you want to offer using the
          other fields provided. Where relevant, please include for each scope
          the level and type of qualification, and the relevant sector subject
          areas (SSAs)/apprenticeship standard/technical subject.
        </Typography>
        <h3 className={classes.sectionHeading}>Question 2</h3>
        <Typography variant="body1" className={classes.formBody}>
          Please explain how the qualifications you wish to offer are similar
          to, or differ from, your current regulated offering in terms of the:
        </Typography>
        <ul className={classes.formBody}>
          <li>
            <Typography>Description of qualification</Typography>
          </li>
          <li>
            <Typography>Qualification level</Typography>
          </li>
          <li>
            <Typography>Sector subject area </Typography>
          </li>
          <li>
            <Typography>
              Volumes of the new qualifications you forecast to certificate
            </Typography>
          </li>
          <li>
            <Typography>Assessment methods used</Typography>
          </li>
          <li>
            <Typography>Levels of expertise required</Typography>
          </li>
        </ul>
        <h3 className={classes.sectionHeading}>Question 3</h3>
        <Typography variant="body1" className={classes.formBody}>
          Please provide details of how you will ensure you have the capacity
          and capability (including people and finances) to develop, deliver and
          award the qualifications you wish to offer.
        </Typography>
        <h3 className={classes.sectionHeading}>Question 4</h3>
        <Typography variant="body1" className={classes.formBody}>
          In addition, please provide the following information for each of the
          apprenticeship End-Point Assessment (EPAs) you wish to offer (if
          applicable):
        </Typography>
        <ul className={classes.formBody}>
          <li>
            <Typography>
              number of anticipated and confirmed registrations or entries for
              these EPAs
            </Typography>
          </li>
          <li>
            <Typography>
              an indication of how advanced each EPA is in terms of its
              development
            </Typography>
          </li>
          <li>
            <Typography>
              Are there any actual or potential conflicts of interest that may arise from this expansion?
            </Typography>
          </li>
        </ul>
      </Paper>
    </>
  );
};
